import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuthContext } from '../../hooks/useAuthContext';
import DesktopSidebar from './DesktopSidebar';
import MobileBottomNav from './MobileBottomNav';
import FeedbackButton from '../features/feedback/FeedbackButton';

const ResponsiveNavigation = () => {
    const { user, authIsReady } = useAuthContext();
    const location = useLocation();
    const [isMobile, setIsMobile] = useState(false);
    
    // Check if we're on the onboarding route
    const isOnboarding = location.pathname === '/onboarding';

    // Handle responsive behavior with window resize
    useEffect(() => {
        const checkScreenSize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        // Initial check
        checkScreenSize();

        // Add event listener with debouncing
        let timeoutId;
        const debouncedResize = () => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(checkScreenSize, 100);
        };

        window.addEventListener('resize', debouncedResize);
        
        // Cleanup
        return () => {
            window.removeEventListener('resize', debouncedResize);
            clearTimeout(timeoutId);
        };
    }, []);

    // Don't render navigation if auth isn't ready yet
    if (!authIsReady) {
        return null;
    }

    // Don't render navigation for unauthenticated users
    if (!user) {
        return null;
    }

    // Don't render navigation during onboarding
    if (isOnboarding) {
        return null;
    }

    return (
        <div className="navigation-transition">
            {/* Desktop: Show sidebar on md screens and up */}
            <div className="hidden md:block">
                <DesktopSidebar />
            </div>

            {/* Mobile: Show bottom nav on screens smaller than md */}
            <div className="block md:hidden">
                <MobileBottomNav />
                {/* Mobile Bug Report Button - Fixed position top-right, hidden on desktop */}
                <div className="md:hidden">
                    <FeedbackButton 
                        variant="floating" 
                        position="top-right"
                        style="secondary"
                        icon="lightbulb"
                    />
                </div>
            </div>
        </div>
    );
};

export default ResponsiveNavigation;